<template>
  <v-app id="app">
    <client-topbar @drawerEvent="drawer = !drawer"/>
    <client-sidebar/>
    <v-main style="background: #f5f5f540">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import ClientTopbar from "@/components/ClientTopbar";
import ClientSidebar from "@/components/ClientSidebar";

export default {
  name: "clientLayout",
  components: {ClientSidebar, ClientTopbar},
  data: () => ({
    cards: ["Today", "Yesterday"],
    drawer: null,
  }),
}
</script>

<style scoped>

</style>